export default {
    'delete-message-vacation': 'Are you sure you want to delete this vacation?'
};
